import * as CookieConsent from "vanilla-cookieconsent";

export default function MapPlaceholder() {
  return (
    <div
      className="ee-map-placeholder"
      role="region"
      aria-label="Mappa del centro estetico Estetica Elite"
    >
      <div className="ee-map-placeholder__content">
        <p className="ee-map-placeholder__text">
          Per visualizzare la mappa, accetta i cookie di funzionalità.
        </p>
        <button
          type="button"
          onClick={() => CookieConsent.acceptCategory(["functionality"])}
          aria-label="Accetta i cookie di funzionalità per visualizzare la mappa"
          className="ee-btn ee-btn-primary ee-map-placeholder__btn"
        >
          Accetta cookie di funzionalità
        </button>
      </div>
    </div>
  );
}
